import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { AppSelect } from './InputComponents';
import multiItemQuestion from './MultiItemQuestion.component';
import { arrayOfNumbers } from '../../../services/util.service';
import useStyles from "./Contraception.style";
import PregnancyTestIcon from "../../../images/pregnancytest.svg";
import { contraceptiveMethods } from "../../../data/db";
import { MobileButton } from '../../../components/MobileButton';
import { useTranslation } from 'react-i18next';

const Contraception = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [autoUpdate, setAutoUpdate] = useState(false);

    let birthYear = new Date(props.dateOfBirth).getFullYear();
    let firstYear = birthYear + 12;
    let currentYear = new Date(Date.now()).getFullYear();
    let contraceptionYears = arrayOfNumbers(firstYear, currentYear - firstYear + 1);

    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.items]);

    const handleMethodChange = (i, method) => {
        if (['', 'None'].includes(method)) {
            props.onChange(i, 'yearFrom', '')();
            props.onChange(i, 'yearTo', '')();
        };

        props.onChange(i, 'method', method)();
    };

    const handleYearFromChange = (i, method) => {
        if (method === "Unknown time of use") {
            props.onChange(i, 'yearTo', 'Unknown time of use')();
        }
        props.onChange(i, 'yearFrom', method)();
    };

    return (
        <Box className={classes.root}>
            {/* Header */}
            <Box className={classes.imageIcon}>
                <img src={PregnancyTestIcon} alt="Pregnancy Test icon" className={classes.svgIcon} style={{ width: 100 }} />
            </Box>
            <Typography variant="h4" className={classes.title}>
                What type of birth control methods have you used?
            </Typography>
            <Typography className={classes.subTitle}>
            </Typography>
            {props.error && !props.validator.allValid() &&
                <Typography color="error">
                    Please review your answers
                </Typography>
            }
            {props.items.map((method, i) =>
                <Box className={classes.item} key={i}>
                    <Box className={classes.itemHeader}>
                        <span>{t('common.substantive.contraceptive')} #{i + 1}</span>
                        {i !== 0 &&
                            <IconButton aria-label="delete" color="inherit" onClick={props.onRemove(i)}>
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <Typography variant="h5">
                            
                                Birth control method
                                {
                              <span className={props.error && !props.validator.fieldValid(`contraceptive_#${i + 1}_method`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                            <AppSelect
                                id={`method${i + 1}`}
                                label={t('common.substantive.method')}
                                value={method.method}
                                items={['None', ...contraceptiveMethods]}
                                onChange={e => handleMethodChange(i, e.target.value)}
                                error={props.error && !props.validator.fieldValid(`contraceptive_#${i + 1}_method`)}
                                helperText={props.validator.message(`contraceptive_#${i + 1}_method`, method.method, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box
                            className={classes.inputSection}
                            display={method.method === 'None' || method.method === '' ? 'none' : 'block'}
                        >
                            <Typography variant="h5">
                            
                                Period of use
                            {
                              <span className={((props.error && !props.validator.fieldValid(`contraceptive_#${i + 1}_from_year`)) || (props.error && !props.validator.fieldValid(`contraceptive_#${i + 1}_to_year`)) ) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <AppSelect
                                        id={`fromYear${i + 1}`}
                                        label={`${t('common.preposition.from')} ${t('common.substantive.year')}*`}
                                        value={method.yearFrom}
                                        items={["Unknown time of use",...contraceptionYears]}
                                        onChange={e => handleYearFromChange(i, e.target.value)}
                                        error={props.error && !props.validator.fieldValid(`contraceptive_#${i + 1}_from_year`)}
                                        helperText={props.validator.message(`contraceptive_#${i + 1}_from_year`, method.yearFrom, `period_year:${method.method}`)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <AppSelect
                                        id={`toYear${i + 1}`}
                                        label={`${t('common.preposition.to')} ${t('common.substantive.year')}*`}
                                        value={method.yearTo }
                                        disabled={method.yearFrom ==="Unknown time of use" ? true : false}
                                        items={method.yearFrom !=="Unknown time of use" ? [...contraceptionYears, 'Current method'] : [ "Unknown time of use"]}
                                        onChange={props.onChange(i, 'yearTo')}
                                        error={props.error && !props.validator.fieldValid(`contraceptive_#${i + 1}_to_year`)}
                                        helperText={props.validator.message(`contraceptive_#${i + 1}_to_year`, method.yearTo, `period_year:${method.method}`)}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onAdd}
                color="primary"
                label="Add Method"
                endIcon={<AddIcon />}
            />
        </Box >
    );
};

export default multiItemQuestion(Contraception, { yearFrom: '', yearTo: '', method: '' });
